import { render } from "./SaveAsset.vue?vue&type=template&id=2d52e77e"
import script from "./SaveAsset.vue?vue&type=script&lang=js"
export * from "./SaveAsset.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__